import React from 'react';
import './styles.css';
import BasicButton from '../../components/BasicButton';
import FirmReviewList from '../../components/FirmReviewList';
import ListSortControls from '../../components/ListSearch/components/ListSortControls';
import RatingCircleWidget from '../../components/RatingCircleWidget';
import RatingStarsWidget from '../../components/RatingStarsWidget';

const FirmReviews = props => {
  const {
    user,
    firm: { FirmID, Rating, RatingCount, PositiveReviewsCount },
    reviews,
    sortBy,
    hasPagination,
    actions: {
      gotoFormReview,
      gotoReviewsTab,
      handleReviewSorted,
      handleClickReviewLink,
      handleBeforeReviewRatingUpdate,
      handleReviewRatingUpdate,
      handleReviewShowPreviousComments,
      handleReviewAddComment,
      handleReviewRemoveComment,
    },
  } = props;

  const prettyRatingBasedOn =
    'rating' + (parseInt(RatingCount) === 1 ? '' : 's');
  const prettyRecommBasedOn =
    'recommendation' + (parseInt(RatingCount) === 1 ? '' : 's');

  const sortControls = [
    {
      defaultCaption: 'Most Recent',
      toggledCaption: 'Most Recent',
      value: 'recent',
    },
    {
      defaultCaption: 'Most Useful',
      toggledCaption: 'Most Useful',
      value: 'useful',
    },
  ];

  return (
    <div className="firm-tab-reviews">
      <div className="firm-tab-reviews__body">
        <div className="firm-tab-reviews__header">
          <div className="firm-tab-reviews__header-main">
            <h2 className="firm-tab-reviews__title">Reviews</h2>
            <RatingStarsWidget value={Rating} size={22} showNumber={true} />
          </div>

          <div
            className="firm-tab-reviews__header-widgets"
            name="scrollPointReviews"
          >
            <RatingCircleWidget
              color="#f40"
              value={Rating}
              icon="star"
              basedOn={prettyRatingBasedOn}
              maxValue={5}
              basedOnNumber={RatingCount}
            />
            <RatingCircleWidget
              color="#13a03a"
              value={PositiveReviewsCount}
              icon="like"
              basedOn={prettyRecommBasedOn}
              maxValue={100}
              basedOnNumber={RatingCount}
            />
            <BasicButton
              btnWidth={200}
              btnHeight={40}
              btnFontWeight={500}
              btnText="Add a Review"
              btnArrow={false}
              controlFunc={gotoFormReview}
            />
          </div>
        </div>

        {reviews.rows && reviews.rows.length > 0 && (
          <div>
            <div className="firm-review-list__sorting-controls">
              <ListSortControls
                sortBy={sortBy}
                sortControls={sortControls}
                onSortByChangeHandler={handleReviewSorted}
              />
            </div>
          </div>
        )}
      </div>

      <div className="firm-tab-reviews__list">
        <FirmReviewList
          user={user}
          reviews={reviews}
          firmId={FirmID}
          hasPagination={hasPagination}
          actions={{
            onClickReadAllHandler: gotoReviewsTab,
            handleClickReviewLink,
            handleBeforeReviewRatingUpdate,
            handleReviewRatingUpdate,
            handleReviewShowPreviousComments,
            handleReviewAddComment,
            handleReviewRemoveComment,
          }}
        />
      </div>
    </div>
  );
};

export default FirmReviews;
